<template>
  <transition name="fade">
    <div v-if="visible" class="loading-overlay" role="status" aria-live="polite">
      <div class="overlay-card">
        <div class="overlay-icon">⏳</div>
        <h3 class="overlay-title">{{ title }}</h3>
        <div v-if="showProfileDetails" class="overlay-profile" role="group" aria-label="Steam profile syncing">
          <div class="profile-avatar" v-if="profileAvatar">
            <img :src="profileAvatar" :alt="profileNameAlt" loading="lazy">
          </div>
          <div class="profile-meta">
            <span v-if="profileName" class="profile-name">{{ profileName }}</span>
            <span v-if="profileSubtitle" class="profile-subtitle">{{ profileSubtitle }}</span>
          </div>
        </div>
        <p v-if="message" class="overlay-message">{{ message }}</p>
        <div class="progress">
          <div class="indeterminate"></div>
        </div>
        <p v-if="tips" class="overlay-tips">{{ tips }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Loading...' },
    message: { type: String, default: '' },
    tips: { type: String, default: '' },
    profileName: { type: String, default: '' },
    profileAvatar: { type: String, default: '' },
    profileSubtitle: { type: String, default: '' }
  },
  computed: {
    showProfileDetails() {
      return !!(this.profileName || this.profileAvatar || this.profileSubtitle)
    },
    profileNameAlt() {
      if (this.profileName) {
        return `${this.profileName}'s avatar`
      }
      return 'Steam profile avatar'
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity .2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 12, 20, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.overlay-card {
  width: min(90vw, 520px);
  background: rgba(20, 24, 36, 0.9);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  padding: 24px;
  color: #eaf0ff;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}
.overlay-icon { font-size: 36px; margin-bottom: 8px; }
.overlay-title { margin: 4px 0 6px; font-weight: 600; }
.overlay-message { margin: 0 0 12px; opacity: 0.95; }
.overlay-tips { margin-top: 12px; font-size: 12px; color: #cbd6ff; opacity: 0.85; }

.overlay-profile {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin: 12px 0;
  padding: 12px 16px;
  background: rgba(12, 16, 28, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
}
.profile-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 0 0 1px rgba(255,255,255,0.12);
}
.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.profile-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 4px;
}
.profile-name {
  font-weight: 600;
  font-size: 16px;
  color: #fff;
}
.profile-subtitle {
  font-size: 13px;
  opacity: 0.85;
  color: #cbd6ff;
}

.progress { position: relative; height: 6px; background: rgba(255,255,255,0.08); border-radius: 6px; overflow: hidden; }
.progress .indeterminate {
  position: absolute; left: 0; top: 0; bottom: 0; width: 40%;
  background: linear-gradient(90deg, rgba(99,122,255,0.2), #637aff, rgba(99,122,255,0.2));
  animation: move 1.2s infinite ease-in-out;
}
@keyframes move {
  0% { left: -40%; }
  50% { left: 30%; }
  100% { left: 100%; }
}
</style>

